import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';

const statusType = {
  success: {
    ilustration: '/illustration/livestream-question-success.svg',
    text: 'Your question has been sent.',
  },
  error: {
    ilustration: '/illustration/livestream-question-limit.svg',
    text: 'You have reached the limit of sending 3 questions.',
  },
};

interface QuestionResultStatusProps {
  status: 'success' | 'error';
}

function QuestionResultStatus({ status }: QuestionResultStatusProps) {
  return (
    <Flex align="center">
      <Image
        width="180"
        height="135"
        src={statusType[status].ilustration}
        id="livestream-modal-question-result-image"
      />
      <Text
        // @ts-expect-error
        mt="25px"
        size="14px"
        height="19px"
        id="livestream-modal-question-result-status"
      >
        {statusType[status].text}
      </Text>
    </Flex>
  );
}

export default QuestionResultStatus;
